export const UNDERTERMINED = "undetermined";
export const COMPLIANT = "compliant";
export const NOT_COMPLIANT = "not_compliant";

export const COMPLIANT_LABEL = "Compliant";
export const NOT_COMPLIANT_LABEL = "Not Compliant";
export const UNDERTERMINED_LABEL = "Undetermined";

export const COMPLIANCE_STATUSES = {
  undetermined: UNDERTERMINED,
  compliant: COMPLIANT,
  notCompliant: NOT_COMPLIANT,
};

export const JOB_TEMPLATES_TAB = "job_templates";
const JOB_TEMPLATES_TAB_NAME = "Job templates";

export const ARCHIVED_JOB_TEMPLATES_TAB = "archived";
const ARCHIVED_JOB_TEMPLATES_TAB_NAME = "Archived";

export const JOB_TEMPLATES_TABS = {
  [JOB_TEMPLATES_TAB]: JOB_TEMPLATES_TAB_NAME,
  [ARCHIVED_JOB_TEMPLATES_TAB]: ARCHIVED_JOB_TEMPLATES_TAB_NAME,
};

export const JOB_TEMPLATES_TABS_VALUES = [JOB_TEMPLATES_TAB, ARCHIVED_JOB_TEMPLATES_TAB];

export const COMPANY_TAB = "all";
const COMPANY_TAB_NAME = "All companies";

const ARCHIVED_COMPANY_TAB = "premium";
const ARCHIVED_COMPANY_TAB_NAME = "Premium";

export const COMPANY_TABS = {
  [COMPANY_TAB]: COMPANY_TAB_NAME,
  [ARCHIVED_COMPANY_TAB]: ARCHIVED_COMPANY_TAB_NAME,
};

export const COMPANY_TABS_VALUES = [COMPANY_TAB, ARCHIVED_COMPANY_TAB];

export const EXPERT_EMPLOYEE_TAB = "all";
const EXPERT_EMPLOYEE_TAB_NAME = "All employees";

export const EXPERT_ARCHIVED_EMPLOYEE_TAB = "premium";
export const EXPERT_ARCHIVED_EMPLOYEE_TAB_NAME = "Premium";

export const EXPERT_EMPLOYEE_TABS = {
  [EXPERT_EMPLOYEE_TAB]: EXPERT_EMPLOYEE_TAB_NAME,
  [EXPERT_ARCHIVED_EMPLOYEE_TAB]: EXPERT_ARCHIVED_EMPLOYEE_TAB_NAME,
};

export const EXPERT_EMPLOYEE_TABS_VALUES = [EXPERT_EMPLOYEE_TAB, EXPERT_ARCHIVED_EMPLOYEE_TAB];

export const EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED = "Employed";
export const EMPLOYEE_EMPLOYMENT_STATUS_LEAVING = "Leaving";
export const EMPLOYEE_EMPLOYMENT_STATUS_LEAVER = "Leaver";

export const EMPLOYEE_EMPLOYMENT_STATUSES = [
  EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED,
  EMPLOYEE_EMPLOYMENT_STATUS_LEAVING,
  EMPLOYEE_EMPLOYMENT_STATUS_LEAVER,
];

export const EMPLOYEE_EMPLOYMENT_STATUS_MARKING = {
  [EMPLOYEE_EMPLOYMENT_STATUS_EMPLOYED]: "success",
  [EMPLOYEE_EMPLOYMENT_STATUS_LEAVING]: "warning",
  [EMPLOYEE_EMPLOYMENT_STATUS_LEAVER]: "disabled",
};

export const EMPLOYEE_EMPLOYMENT_TYPE_SPONSORED = "Sponsored";

const ACTIVE_EMPLOYEE_TAB = "active";
const LEAVER_EMPLOYEE_TAB = "leavers";

export const EMPLOYEE_TABS_VALUES = [ACTIVE_EMPLOYEE_TAB, LEAVER_EMPLOYEE_TAB];

const ACTIVE_TAB = "active";
const ACTIVE_TAB_NAME = "Active";

export const ARCHIVED_TAB = "archived";
const ARCHIVED_TAB_NAME = "Archived";

export const CANDIDATE_TABS = {
  [ACTIVE_TAB]: ACTIVE_TAB_NAME,
  [ARCHIVED_TAB]: ARCHIVED_TAB_NAME,
};

export const CANDIDATE_TABS_VALUES = [ACTIVE_TAB, ARCHIVED_TAB];
